<template>
  <v-data-table
    :headers="headers"
    :items="formattedItems"
    must-sort
    :no-data-text="$t('texts.employee.noEntries')"
    :no-results-text="$t('texts.noSearchEntries')"
    :footer-props="{ itemsPerPageText: $t('texts.rowsPerPage')}"
    class="elevation-0"
    :loading="loading"
    :hide-default-footer="items.length <= 5 || loading"
  >
    <template v-slot:item.actions="{ item }">
      <v-tooltip color="green" top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon class="mx-0"
            :disabled="!hasActiveSubscription"
            @click="acceptEmployee(item)"
          >
            <v-icon color="green">check</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('texts.confirm') }}</span>
      </v-tooltip>
      <v-tooltip color="red" top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon class="mx-0"
            :disabled="!hasActiveSubscription"
            @click="openDeclineEmployeeDialog(item)"
          >
            <v-icon color="red">close</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('texts.decline') }}</span>
      </v-tooltip>
    </template>
  </v-data-table>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapCompanyEmployeesState, mapActions: mapCompanyEmployeesActions } = createNamespacedHelpers('company/employees');

export default {
  name: 'TableEmployeeAssignment',
  props: {
    loading: {
      type: Boolean,
    },
    items: {
      type: Array,
    },
    hasActiveSubscription: {
      type: Boolean,
    },
  },
  computed: {
    ...mapCompanyEmployeesState([
      'storeEmployeeAssignmentPending',
    ]),
    selectedCompanyId() {
      return this.$route.params.companyId;
    },
    headers() {
      const headers = [
        { text: `${this.$i18n.t('texts.firstName')} ${this.$i18n.t('texts.lastName')}`, value: 'formattedName', align: 'left' },
        { text: this.$i18n.t('texts.insertJobtitle'), value: 'title', align: 'left' },
        { text: this.$i18n.t('texts.startOfWork'), value: 'formattedStartDate', align: 'left' },
        { text: this.$i18n.t('texts.endOfWork'), value: 'formattedEndDate', align: 'left' },
        {
          text: '', value: 'actions', sortable: false, align: 'right',
        },
      ];
      return headers;
    },
    formattedItems() {
      if (this.items.length > 0) {
        return this.items.map((item) => {
          const formattedName = `${item.employee_first_name} ${item.employee_last_name}`;
          const formattedStartDate = this.$options.filters.formatDateShort(item.start_date);
          const formattedEndDate = this.$options.filters.formatDateShort(item.end_date);
          const formattedItem = {
            ...item,
            formattedName,
            formattedStartDate,
            formattedEndDate,
          };
          return formattedItem;
        });
      }
      return [];
    },
  },
  methods: {
    ...mapCompanyEmployeesActions([
      'updateEmployeeAssignment',
    ]),
    openDeclineEmployeeDialog(employee) {
      this.$eventBus.$emit('show-decline-employee-dialog', employee);
    },
    acceptEmployee(employee) {
      const payload = {
        type: 'approve',
        companyId: this.selectedCompanyId,
        entryId: employee.resume_entry_id,
      };
      this.updateEmployeeAssignment(payload);
    },
  },
};
</script>
